// extracted by mini-css-extract-plugin
export default {"container":"SectionFilters-module__container__ZzAsRoa"};